module.exports = __webpack_public_path__ + "static/assets/2008ef9a82bcbaa0dd5fb3fa121c4afc.png";